import React from "react";
import { NumericFormat } from "react-number-format";
import { InputAdornment, SxProps, TextField, Theme } from "@mui/material";

interface CustomNumberComponentProps {
  displayType?: any;
  isString?: boolean;
  prefix?: string;
  suffix?: string;
  allowNegative?: boolean;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
  value?: number | string;
  onValue?: (value: any) => void;
  controlDisabled?: boolean;
  helperText?: string;
  error?: boolean;
  label?: string;
  sx?: SxProps<Theme>;
  placeholder?: string;
  required?: boolean;
  hiddenLabel?: boolean;
  ref?: React.Ref<HTMLInputElement>;
}

export const CustomNumberComponent = ({
  onValue,
  displayType,
  prefix,
  suffix,
  isString,
  allowNegative = true,
  decimalScale = 2,
  fixedDecimalScale = false,
  value,
  controlDisabled,
  sx,
  placeholder,
  required,
  hiddenLabel,
  ref,
  ...others
}: CustomNumberComponentProps) => {
  const endAdornment = () => (suffix ? <InputAdornment position="start">{suffix}</InputAdornment> : null);
  const startAdornment = () => (prefix ? <InputAdornment position="start">{prefix}</InputAdornment> : null);

  return (
    <NumericFormat
      {...others}
      inputRef={ref}
      hiddenLabel={hiddenLabel}
      required={required}
      placeholder={placeholder}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      value={value}
      customInput={TextField}
      slotProps={{
        input: {
          startAdornment: startAdornment(),
          endAdornment: endAdornment(),
        },
      }}
      decimalSeparator=","
      thousandSeparator="."
      size="small"
      decimalScale={decimalScale}
      fixedDecimalScale={fixedDecimalScale}
      inputMode={"decimal"}
      displayType={displayType ? displayType : "input"}
      onFocus={(event) => {
        event.target.select();
      }}
      onValueChange={(values) => {
        const { floatValue } = values;
        if (onValue && !isString) {
          onValue(floatValue);
        } else onValue(values.value);
      }}
      allowNegative={allowNegative}
      disabled={controlDisabled}
    />
  );
};
